const SHARE_FIELDS = [
  { k: "share_title", label: "Share title (optional, shown when the link is shared)" },
  { k: "share_image", label: "Share image (optional, defaults to cover)", type: "image" },
];

export const RESOURCES = {
  galleries: {
    label: "Galleries", singular: "gallery",
    fields: [
      { k: "title", label: "Title", required: true },
      { k: "slug", label: "URL slug (auto if blank)" },
      { k: "location", label: "Location" },
      { k: "description", label: "Description", type: "textarea" },
      { k: "cover_image", label: "Cover image", type: "image" },
      { k: "images", label: "Photographs", type: "images" },
      ...SHARE_FIELDS,
      { k: "published", label: "Published", type: "switch", default: true },
    ],
    summary: (r) => `${r.location || "—"} · ${r.images?.length || 0} photos`,
  },
  articles: {
    label: "Articles", singular: "article",
    fields: [
      { k: "title", label: "Title", required: true },
      { k: "slug", label: "URL slug (auto if blank)" },
      { k: "category", label: "Category" },
      { k: "author", label: "Author" },
      { k: "excerpt", label: "Excerpt", type: "textarea" },
      { k: "cover_image", label: "Cover image", type: "image" },
      { k: "body", label: "Body (blank line = new paragraph, '## ' = heading)", type: "textarea", rows: 14 },
      ...SHARE_FIELDS,
      { k: "published", label: "Published", type: "switch", default: true },
    ],
    summary: (r) => r.category || "—",
  },
  locations: {
    label: "Locations", singular: "location",
    fields: [
      { k: "title", label: "Name", required: true },
      { k: "slug", label: "URL slug (auto if blank)" },
      { k: "region", label: "Region" },
      { k: "kind", label: "Type", type: "select", options: ["beach", "club", "retreat", "other"], default: "beach" },
      { k: "status", label: "Status", type: "select", options: ["Clothing-optional (recognised)", "Club / private", "Informal — check locally"], default: "Informal — check locally" },
      { k: "summary", label: "Short summary", type: "textarea", rows: 2 },
      { k: "access", label: "Access notes", type: "textarea", rows: 2 },
      { k: "body", label: "Full notes", type: "textarea", rows: 10 },
      { k: "cover_image", label: "Cover image", type: "image" },
      { k: "lat", label: "Latitude (for live weather, e.g. -36.85)" },
      { k: "lon", label: "Longitude (e.g. 174.76)" },
      ...SHARE_FIELDS,
      { k: "published", label: "Published", type: "switch", default: true },
    ],
    summary: (r) => `${r.region || "—"} · ${r.kind || ""}`,
  },
  events: {
    label: "Events", singular: "event",
    fields: [
      { k: "title", label: "Title", required: true },
      { k: "date", label: "Date", type: "date" },
      { k: "time", label: "Time (e.g. 10am – 4pm)" },
      { k: "location", label: "Location" },
      { k: "description", label: "Description", type: "textarea" },
      { k: "link", label: "More-info link (optional)" },
      { k: "cover_image", label: "Image (optional)", type: "image" },
      { k: "published", label: "Published", type: "switch", default: true },
    ],
    summary: (r) => `${r.date || "No date"} · ${r.location || "—"}`,
  },
  notices: {
    label: "Regional notices", singular: "notice",
    fields: [
      { k: "title", label: "Name", required: true },
      { k: "country_codes", label: "Country codes (comma separated, * = default)", type: "csv" },
      { k: "level", label: "Level", type: "select", options: ["info", "caution", "restricted"], default: "info" },
      { k: "message", label: "Message shown to visitors", type: "textarea" },
      { k: "active", label: "Active", type: "switch", default: true },
    ],
    summary: (r) => `${(r.country_codes || []).join(", ")} · ${r.level}`,
  },
  pages: {
    label: "Pages", singular: "page",
    fields: [
      { k: "title", label: "Title", required: true },
      { k: "slug", label: "Slug (about, legal, age-notice)" },
      { k: "body", label: "Body", type: "textarea", rows: 14 },
      { k: "published", label: "Published", type: "switch", default: true },
    ],
    summary: (r) => `/${r.slug}`,
  },
};
